import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { ApiService } from '../../service/api_service';
import * as $ from 'jquery';

@Component({
    selector: 'app-headqtrallocationreport',
    template: require('./headqtrallocationreport.component.html'),
    styles: []
})
export class HeadqtrAllocationReportComponent implements OnInit {

    private columnDefs;
    private rowData;
    private rowHeight;
    defaultColDefine;
    HQSearchModel: any;
    HQList: any;
    busy: Subscription;
    StateList: any;
    api: any;
    gridColumnApi: any;
    token:any;

    f_chkString(p_value) {
        var Val = (p_value? p_value.toString(): "").trim();
        return Val;
    }

    f_ChkNum(p_value) {
        var Num = Number(p_value);
        if(Num){
            return Num;
        }
        return 0;
    }

    static parameters = [ApiService, ActivatedRoute, Router, HttpClient]
    constructor(private apiService: ApiService, private activatedRoute: ActivatedRoute, private router: Router, private http: HttpClient ) {

        this.columnDefs = [
            { headerName: 'S.No.', valueGetter: "node.rowIndex + 1", width: 80 },
            { headerName: 'Head Qtr', field: 'HQName', width: 200 },
            { headerName: 'SO', field: 'SO', width: 200 },
            { headerName: 'ASM', field: 'ASM', width: 200 },
            { headerName: 'RSM', field: 'RSM', width: 200 },
            { headerName: 'CSM', field: 'CSM', width: 200 },
            { headerName: 'SM', field: '', width: 200 },
            // { headerName: 'MD', field: '', width: 200 },
            { 
                headerName: 'Status', field: "", cellRenderer: function (params) {
                    var eDiv = document.createElement('div');
                    eDiv.innerHTML = ((params.data.status)? `ENABLE`: `DISABLE`);
                    return eDiv;
                }
            },
            // { headerName: 'HQ Remarks', field: "hqremarks" },
            // { headerName: 'Division Group', field: "divisiongroup" },
            { headerName: 'State', field: "StateName" },
        //     { headerName: 'Alloted Strength', field: "CallDate" },
        //     {
        //         headerName: 'Alloted Stockist', field: '', width: 150, cellRenderer: function (params) {
        //             var eDiv = document.createElement('div');
        //             eDiv.innerHTML = `
        //   <a href="">15<i class="icon-edit pl-2"></i></a>
        // `;
        //             return eDiv;
        //         }
        //     },
        //     {
        //         headerName: 'Action', field: '', width: 100, cellRenderer: function (params) {
        //             var eDiv = document.createElement('div');
        //             eDiv.innerHTML = `
        //             <div class="grid_actions">
        //                 <span class="viewBtn grid_actions_item" data-target="#addEmployeeDAMaster" data-toggle="modal"><i class="icon-view"></i></span>
        //                 <span class="addBtn grid_actions_item" data-target="#addEmployeeDAMaster" data-toggle="modal"><i class="icon-delete"></i></span>
        //             </div>
        //             `;
        //             return eDiv;
        //         }
        //     },
        ];
        this.defaultColDefine = { resizable: true };
        this.rowHeight = 50;
    }

    ngOnInit() {
        this.token = JSON.parse(sessionStorage.getItem("currentUser"));
        this.rowData = [];
        this.HQSearchModel = {};
        this.HQSearchModel.StateID = 0;
        this.HQSearchModel.HQID = 0;
        this.HQSearchModel.Status = 1;
        this.HQSearchModel.LoginId=this.token.id;
        this.HQList = [];
        this.getHeadQuarterList();        
        this.getStateList(); 
        $('#filter-option').trigger('click');       
    }

    onGridReady = (params) => {
        this.api = params.api;
        this.gridColumnApi = params.columnApi;
    }

    onFilterTextBoxChanged() {
        this.api.setQuickFilter($('#filter-text-box').val());
        this.api.refreshCells();
    }

    onBtnExport() {
        this.api.exportDataAsCsv({ fileName: 'HeadQuarterAllocationReport' });
    }

    GetHeadQuarterAllocationList(){
        var data = this.HQSearchModel;
       // console.log(data);
       this.busy = this.http.post('/api/Report/GetHeadQuarterAllocationList', data).subscribe((res) => {
            this.rowData = res;
        })
    }

    getHeadQuarterList(){
        this.apiService.getHeadQuarterList()
        .subscribe((res: any) => {
            this.HQList = res.data;
        });
    }

    getStateList(){
        this.apiService.getState()
        .subscribe((res: any) => {
            this.StateList = res.data;
        });
    }

    OnBtnGoClick(){
        this.GetHeadQuarterAllocationList();
    }
}
